import { roomSettingsServiceBaseUrl } from "@coworker/functions/src/triggers/cloud-services.helper";
import { getEnvironmentId, isChineseEnvironment } from "@coworker/reusable";

const isChina = isChineseEnvironment();

export const ROOM_SETTINGS_SERVICE_URL = roomSettingsServiceBaseUrl(
  getEnvironmentId(),
  isChina
);
